"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIE = void 0;
function checkNavigator(testExp) {
    // Depending on the execution environment, navigator might either be undefined or throw a ReferenceError.
    try {
        return testExp.test(navigator.userAgent);
    }
    catch (_a) {
        return false;
    }
}
exports.isIE = checkNavigator(/Trident/);
//# sourceMappingURL=BrowserDetection.js.map